import React from "react";
import PropTypes from "prop-types";
import styles from "./index.css";
import withTranslation from "../../../../translation";

const USSalesTax = ({ countryCode, USSalesTaxToggle, formatTranslation }) =>
  countryCode === "US" && USSalesTaxToggle ? (
    <small className={styles.USSalesTax}>
      {formatTranslation("MiniBag.SubTotal.USSalesTax")}
    </small>
  ) : null;

USSalesTax.propTypes = {
  countryCode: PropTypes.string.isRequired,
  USSalesTaxToggle: PropTypes.bool.isRequired,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(USSalesTax);



// WEBPACK FOOTER //
// ./template/components/MiniBag/Footer/SubTotal/USSalesTax/index.js